<!--
 * @Description: 值班日志
 * @Author: PF
 * @Date: 2023-09-01 10:00:43
 * @LastEditors: PF
 * @LastEditTime: 2025-07-17 15:24:52
-->
<template>
  <div>
    <el-dialog class="w800 hp75" :model-value="openZhiBanRiZhi" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">值班日志</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openZhiBanRiZhi', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-form ref="ruleFormRef" :model="ruleForm" label-width="120px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="值班人员">
              {{ row.zbryxm }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机号码">
              {{ row.yddh }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="值班类别">
              {{ row.zblbmc }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="值班日期">
              {{ row.zbrq }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="值班内容名称">
              {{ row.zbnrmc }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="值班时间">
              {{ row.zbkssj }}<span v-if="row.zbkssj && row.zbjssj" class="ml5 mr5">-</span>{{ row.zbjssj }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="接班人">
              <el-select v-model="row.jbrys" multiple clearable filterable>
                <el-option v-for="item in jbrData" :key="item.zbryid" :label="item.zbryxm" :value="item.zbryid" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="值班状况">
              <el-radio-group v-model="ruleForm.zbzk">
                <el-radio v-for="(item, index) in zbzkData" :key="index" :label="item.value">{{item.name}}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <div style=" height: 50px; display: flex; align-items: center; justify-content: center; font-weight: bold;">值班日志</div>
          </el-col>
        </el-row>
        <el-descriptions :column="2" border>
          <!-- <el-descriptions-item label="存在问题" label-align="right" align="left" width="150px" span="2">
            <el-input v-model="ruleForm.czwt" type="textarea" placeholder="请输入" resize="none" :autosize='{minRows: 2, maxRows: 2}' />
          </el-descriptions-item>
          <el-descriptions-item label="处理结果" label-align="right" align="left" span="2">
            <el-input v-model="ruleForm.cljg" type="textarea" placeholder="请输入" resize="none" :autosize='{minRows: 2, maxRows: 2}' />
          </el-descriptions-item> -->
          <el-descriptions-item v-for="(item,index) in row.zblbrzmbs" :key="index" :label="item.mbmc" label-align="right" align="left" width="200px" span="2">
            <el-input v-if="zbrzmblxData.wb === item.lx" v-model="item.nr" type="textarea" placeholder="请输入" resize="none" :autosize='{minRows: 2, maxRows: 2}' />
            <span class="ml10 mr10" v-if="zbrzmblxData.dx === item.lx" style="display: flex;flex-direction: column;">
              <el-radio v-for="(val,v) in item.xztxxs" :key="v" v-model="val.sfmrz" :label="true" @click="sfmrzClick(index,v)">{{ val.xxnr }}</el-radio>
            </span>
            <span class="ml10 mr10" v-if="zbrzmblxData.dxs === item.lx" style="display: flex;flex-direction: column;">
              <el-checkbox v-for="(val,v) in item.xztxxs" :key="v" v-model="val.sfmrz" :label="false">{{ val.xxnr }}</el-checkbox>
            </span>
          </el-descriptions-item>
        </el-descriptions>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button link type="primary" @click="openRiZhiJiLu=true">值班日志记录</el-button>
          <div class="footer_but">
            <el-button type="primary" @click="submit()">保存</el-button>
            <el-button type="info" @click="closeWindow('openZhiBanRiZhi', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
  <zhibanrizhijilu v-if="openRiZhiJiLu" v-model:openDetail="openRiZhiJiLu" :row="row" />
</template>
<script setup>
import { defineEmits, ref, defineProps, watch } from 'vue'
import { closeWindow, loadSelect, actionPost } from '@/api/common.js'
import { warningPrompt } from '@/utils/promptInfo.js'
import zhibanrizhijilu from '@/pages/bangong/zhibanguanli/wodezhiban/zhibanrizhijilu.vue'

const props = defineProps({
  openZhiBanRiZhi: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openZhiBanRiZhi', 'ReturnData'])
const ruleFormRef = ref(null)
const ruleForm = ref({})

const row = ref()
const jbrData = ref([])
const zbzkData = ref([])
const zbrzmblxData = ref({ listZhuangTai: [] })

// 单选
const sfmrzClick = (i, v) => {
  row.value.zblbrzmbs.forEach((element, index) => {
    if (i === index) {
      element.xztxxs.forEach((ele, e) => {
        if (v === e) {
          ele.sfmrz = true
        } else {
          ele.sfmrz = false
        }
      })
    }
  })
}

watch(
  () => props.openZhiBanRiZhi,
  () => {
    if (props.openZhiBanRiZhi) {
      ruleForm.value.id = props.row.dbgzid
      const o = {
        url: '/api/v2/bangong/zhibanrenyuanrizhijilu/' + props.row.dbgzid,
        data: {}
      }
      actionPost(o).then((res) => {
        if (res.code === 200) {
          row.value = res.data
          loadSelect({
            url: '/api/v2/bangong/zhibanrizhimuban/zhibanrizhileixing',
            data: zbrzmblxData
          })
          loadSelect({
            url: '/api/v2/bangong/zhibanrenyuanjilu/jiebanren',
            data: jbrData,
            parms: { zbrwid: res.data.zbrwid, zbrq: res.data.zbrq }
          })
          loadSelect({
            url: '/api/v2/bangong/zhibanrenyuanrizhijilu/zhibanzhuangkuang',
            data: zbzkData,
            loadSuccess: function (res) {
              ruleForm.value.zbzk = res.data[0].value
            }
          })
        } else {
          warningPrompt(res.message)
        }
      })
    }
  },
  { deep: true, immediate: true }
)

const openRiZhiJiLu = ref(false)

// 提交
const submit = async () => {
  ruleForm.value.jbrys = row.value.jbrys.map((item) => ({ jbrid: item }))
  ruleForm.value.zbnrs = row.value.zblbrzmbs.map((item) => ({
    mbzdmc: item.mbmc,
    nr: item.nr,
    lx: item.lx,
    sx: item.sx,
    xxnrs: item.xztxxs
  }))
  const o = {
    url: '/api/v2/bangong/zhibanrenyuanrizhijilu',
    data: ruleForm.value
  }
  actionPost(o).then((res) => {
    if (res.code === 200) {
      closeWindow('openZhiBanRiZhi', emits, true)
    } else {
      warningPrompt(res.message)
    }
  })
}
</script>

<style lang="less" scoped>
.el-checkbox {
  margin-right: 0;
}
:deep(.el-radio__label),
:deep(.el-checkbox__label) {
  width: 100% !important;
  text-overflow: ellipsis;
  white-space: normal;
  line-height: 18px;
  padding-left: 0;
  margin-left: 5px;
  margin-right: -5px;
}
</style>
